import type { QueryKey, UseQueryOptions } from '@tanstack/react-query';
import type { OptionalQueryOptions, QueryApiOptions } from '../../types/types';
import {
  getProductAvailabilityForAllStores,
  getProductAvailabilityForCurrentStore,
  ProductAvailabilityForAllStoresParams,
  ProductAvailabilityForAllStoresResponse,
  ProductAvailabilityForCurrentStoreParams,
  ProductAvailabilityForCurrentStoreResponse,
} from './store-erp.api';

export const storeErpQueryKeys = {
  all: () => ['product'] as QueryKey,
  availabilityForCurrentStore: ({ storeNumber, storeId, productId }: ProductAvailabilityForCurrentStoreParams) =>
    [...storeErpQueryKeys.all(), 'currentStore', storeNumber, storeId, productId] as QueryKey,
  availabilityForAllStores: ({ skuId }: ProductAvailabilityForAllStoresParams) =>
    [...storeErpQueryKeys.all(), 'allStores', skuId] as QueryKey,
};

export const storeErpQueries = (apiOptions: QueryApiOptions) => ({
  getProductAvailabilityForCurrentStore: <TReturnData = ProductAvailabilityForCurrentStoreResponse>(
    params: ProductAvailabilityForCurrentStoreParams,
    options: OptionalQueryOptions<ProductAvailabilityForCurrentStoreResponse, TReturnData> = {}
  ): UseQueryOptions<ProductAvailabilityForCurrentStoreResponse, Error, TReturnData> => ({
    ...options,
    queryKey: storeErpQueryKeys.availabilityForCurrentStore(params),
    queryFn: () => getProductAvailabilityForCurrentStore(apiOptions, params),
  }),
  getProductAvailabilityForAllStores: <TReturnData = ProductAvailabilityForAllStoresResponse>(
    params: ProductAvailabilityForAllStoresParams,
    options: OptionalQueryOptions<ProductAvailabilityForAllStoresResponse, TReturnData> = {}
  ): UseQueryOptions<ProductAvailabilityForAllStoresResponse, Error, TReturnData> => ({
    ...options,
    queryKey: storeErpQueryKeys.availabilityForAllStores(params),
    queryFn: () => getProductAvailabilityForAllStores(apiOptions, params),
  }),
});
